import type { ReactNode } from 'react';

import BpkSkeleton, {
  SKELETON_TYPES,
  SIZE_TYPES,
} from '@skyscanner/backpack-web/bpk-component-skeleton';

import STYLES from './TranslationContent.module.scss';

type Props = {
  children: ReactNode;
  isPending?: boolean;
  withTitle?: boolean;
};

const TranslationContent = ({ children, isPending, withTitle }: Props) => {
  if (isPending) {
    return (
      <div className={STYLES.TranslationContent}>
        {withTitle && (
          <BpkSkeleton
            type={SKELETON_TYPES.headline}
            size={SIZE_TYPES.default}
          />
        )}
        <BpkSkeleton
          type={SKELETON_TYPES.bodyText}
          size={{ width: '100%', height: '8px' }}
        />
        <BpkSkeleton
          type={SKELETON_TYPES.bodyText}
          size={{ width: '100%', height: '8px' }}
        />
        <BpkSkeleton
          type={SKELETON_TYPES.bodyText}
          size={{ width: '60%', height: '8px' }}
        />
      </div>
    );
  }

  return <div>{children}</div>;
};

export default TranslationContent;
